import { postBackofficeAuthGetSession } from '@repo/sdk/gen'
import { redirect } from '@tanstack/react-router'
import type { RouterContext } from '@/router'

export async function requireBackofficeSession({
	context
}: {
	context: RouterContext
}) {
	const response = await postBackofficeAuthGetSession()
	context.queryClient.setQueryData(['auth', 'session'], response.data)
	if (response.data.sessionType !== 'authenticated') {
		throw redirect({ to: '/login' })
	}
}
